import client from './client';

export function getDeepDocument(signal) {
  return client.get('/api/einsatz-documents/deep', { signal });
}

export function getDeepFile(url, signal) {
  if (!/^\/api\/einsatz-documents\/deep\/(download|files\/[a-z0-9][a-z0-9._-]*)$/.test(url)) {
    throw new Error('Ungültige DEEP-Dokumentadresse.');
  }
  return client.get(url, { responseType: 'blob', signal });
}
